import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorker from './serviceWorker'
import { LoadingSpinerComponent } from './components/generics/Loading'
import './i18n'

const container = document.getElementById('root')
if (container == null) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/site/biz_link">
      <LoadingSpinerComponent />
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

serviceWorker.unregister()
reportWebVitals()
